<sdps-modal-beta sdps-title="Inherited IRA Calculator Disclosure" id="ira-calculator-modal" (closeButtonClick)="onCloseClick()">
  <div slot="modal-body">
    <div class="sdps-text-body">
      Please be advised that this link will take you to Schwab.com. The RMD Calculator is a resource that is meant for general informational
      purposes only and content in this page is designed for individual investor customers. The information generated in the RMD calculator
      is not intended to substitute professional tax, legal or investment planning advice. You can access the RMD calculator by clicking the
      "Calculate RMD" button.
    </div>
  </div>
  <div slot="modal-footer">
    <button type="button" (click)="rmdCalcLinkClicked()" class="sdps-button sdps-button--medium sdps-button--primary">Calculate RMD</button>
  </div>
</sdps-modal-beta>
